import { CSSProperties, forwardRef } from 'react'

import styles from './styles.module.css'

type Props = {
    className?: string
    size?: number
}

export const Spinner = forwardRef<HTMLDivElement, Props>(({className, size}, ref) => {
    const _className = className ? `${className} ${styles.root}` : styles.root
    const borderStyle: CSSProperties | undefined = typeof size === 'number' ? {
        transform: `scale(${ size / 40 })`,
    } : undefined

    return (
        <div className={ _className } style={borderStyle} ref={ ref }>
            <span className={ styles.border } />
        </div>
    )
})
